import { React, useEffect, useState,useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  JobCardContainer,
  JobListColumn,
  JobCardHeader,
  HaberForm,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Card, Radio, Table, Tooltip, Tabs, Menu, Dropdown, Checkbox, Col, Row } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import {
  downloadJobcardsExcel,
    getAllJobCards,
  getFilteredJobcards,
  getJobCardsInfo,
  searchJobCardByJobcardNo
} from "../../../Services/deckleMatchServices";
// import { getProductsData } from "../../../Services/productServices";
import moment from "moment";
import {
  TableList,
  RadioButtonStyle,
  Styled,
  StyledTab,
  DisabledButtonStyle
} from "../../pageStyled";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import CardShimmer from "../../../Components/CardShimmer/cardShimmer";
import machineIcon from "../../../Assets/Icons/machine-icon.svg";
import { getUnitData } from "../../../Services/measurementService";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import { changeProductionJobCardState } from "../../../Services/productionPlanningServices";
import OrderFilter from "../../../Components/OrderFilter/Filter";
import styled from "styled-components";
import GenerateReportModal from "../../../Components/Modal/GenerateReportModal";

const OrderDetails = styled.div`
  .pendingDetailsStyle {
    display: block;
    text-align: right;
    padding-bottom: 16px;
    font-size: 14px;
    font-family: var(--sf-pro-display-m);
    color: var(--theme-color);
    line-height: 16px;
  }
  .pendingOrderStyle {
    padding-right: 20px;
  }
`;

const Panes = Tabs.TabPane;

const JobcardSummaryReport = (props) => {
  const navigate = useNavigate();
  
    const [orderManagementSettings,setOrderManagementSettings]=useState(JSON.parse(localStorage.getItem("order-management-settings")))
    const [deckleManagementSettings,setDeckleManagementSettings]=useState()
  /*------------------------------------------------------------------------------------------------------*/

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
      JSON.parse(localStorage.getItem("setting-data"))
    );
  const [totalRecords, setTotalRecords] = useState();
  const [allJobCardsIds, setAllJobCardsIds] = useState([]);
  const [jobCardsList, setJobCardsList] = useState();
  const [unitData, setUnitData] = useState();
  const [tableData, setTableData] = useState();
  const [tableJobCardState, setTableJobCardState] = useState(orderManagementSettings?.fetch_balance_quantity?.value
      ? 'active' : 'pending');
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: 50,
  });
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
  const [modifiedFilterLabel,setModifiedFilterLabel] = useState("All");
  const [rendering, setRendering] = useState(true);
//   const [coloumnDataJobCards, setColoumnDataJobCards] = useState(
//     orderManagementSettings?.fetch_orders_from_erp?.value
//       ? [
//           {
//             state: "active",
//             classname: "completed-job-cards",
//             heading: "Active Job Cards",
//             jobcards: activeJobcards,
//             hasMore: true,
//             currentPage: 1,
//           },
//           {
//               state: "under_review",
//               classname: "in-production",
//               heading: "Under Review Job Cards",
//               jobcards: underReviewJobcards,
//               hasMore: true,
//               currentPage: 1,
//             },
         
//           {
//             state: "complete",
//             classname: "completed-job-cards",
//             heading: "Completed Job Cards",
//             jobcards: completeCards,
//             hasMore: true,
//             currentPage: 1,
//           },
//            {
//             state: "cancel",
//             classname: "completed-job-cards",
//             heading: "Cancelled Job Cards",
//             jobcards: cancelledJobcards,
//             hasMore: true,
//             currentPage: 1,
//           },
          
//         ]
//       : [
//           {
//             state: "pending",
//             classname: "pending-for-approval",
//             heading: "Pending for approval",
//             jobcards: pendingCards,
//             hasMore: true,
//             currentPage: 1,
//           },
//           {
//             state: "rejected",
//             classname: "rejected-job-cards",
//             heading: "Rejected Job Cards",
//             jobcards: rejectedCards,
//             hasMore: true,
//             currentPage: 1,
//           },
//           {
//             state: "approved",
//             classname: "approved-job-cards",
//             heading: "Approved Job Cards",
//             jobcards: approvedCards,
//             hasMore: true,
//             currentPage: 1,
//           },
//           {
//             state: "in_production",
//             classname: "in-production",
//             heading: "In Production",
//             jobcards: inProductionCards,
//             hasMore: true,
//             currentPage: 1,
//           },
//           {
//             state: "complete",
//             classname: "completed-job-cards",
//             heading: "Completed Job Cards",
//             jobcards: completeCards,
//             hasMore: true,
//             currentPage: 1,
//           },
//         ]
//   );
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [loadings,setLoadings] = useState(true);
  const [isGenerateReportModalVisible,setGenerateReportModalVisible] = useState(false);
  const [isAllSelectedClicked, setIsAllSelectedClicked] = useState(false);
  const scrollContainerRef = useRef(null);
  const [isReportGenerating,setReportGenerating] = useState(false);

  const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);
  const format = settingsData?.settings?.product_spec?.format || "";
  const JobcardStatus =orderManagementSettings?.fetch_balance_quantity?.value ? 
  [
    { label : "Active", value: "active" },
    { label: "Under Review", value: "under_review" },
    { label: "Completed", value: "complete" },
    {  label: "Cancelled", value: "cancel" },

  ]
  :
  [ 
  {  label: "Pending for approval", value: "pending" },
    {  label: "Rejected", value: "rejected" },
    {  label: "Approved", value: "approved" },
    { label: "In Production", value: "in_production" },
    {  label: "Completed", value: "complete" },
  ];
  useEffect(() => {
    ( async() => {
    await getUnitData().then((response) => {
      let data = response.data;
      setUnitData(data);
    })
    .catch((error) => {
      console.log(error);
    });
  })();
  }, []);

  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  }

  

  const onChange = (pagination, filters, sorter, extra, orderState) => {
    // setPaginationParams({
    //   page: 1,
    //   size: 10,
    // });
    setPaginationParams({
      page: pagination.current,
      size: pagination.pageSize,
    });
    fetchJobCardsList({page: pagination.current,
      size: pagination.pageSize,} , searchValue,appliedFilters)
  };

  
 const applyfilter = (filter) => {
    let temp = appliedFilters;
    let alreadySetFilter = false;
    if(filter.type == 'updated_date' && filter.start_date =="Invalid date")
    {
      removeFilter(filter);
      return;
    }
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.filter((item)=>item.type!="updated_date").map(formatFilters));
    setPaginationParams({
      page: 1,
      size: 50,
    });
    fetchJobCardsList({
      page: 1,
      size: 50,
    },searchValue,tempVar)
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "machine_type":
        const typeValue =
        item.machine_type === "rewinder"
          ? "Rewinding"
          : item.order_type === "cutter"
            ? "Cutting"
            : "Rewinding or Cutting";
      return {
        type: item.type,
        formattedType: "Finishing Process Type",
        operand: "equals",
        value: typeValue,
        // tooltip: `Order Type equals ${typeValue}`,
      };
       case "jc_status":
       const value =
          item.status.length > 1
            ? `${item.status[0]} or ${item.status.length - 1} others`
            : `${item.status[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Status",
          operand: "equals",
          value,
          // tooltip: customerToolTip,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${
                item.grades.length - 1
              } others`
            : `${item.grades[0].grade}` + (item.grades[0].qualities?.length ? `"(${item.grades[0].qualities.join()})"` : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
    }
  };

  const removeFilter = (filter) => {
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    setPaginationParams({
      page: 1,
      size: 50,
    });
    fetchJobCardsList({
      page: 1,
      size: 50,
    },searchValue,filterList)
  };

  const fetchJobCardsList = async (params,value,filter) => {
    console.log();
    
    try {
      setLoadings(true);
      const jobCardsData = await getAllJobCards(params,value,filter);
      if(!jobCardsData?.jobcards?.length){
        setEmptyStateLabel("noData");
      }
      else{
        setEmptyStateLabel();
      }
      setTotalRecords(jobCardsData.total_jobcards);
      setAllJobCardsIds(jobCardsData.all_jobcard_ids);
      setJobCardsList(jobCardsData.jobcards);
      setLoadings(false);
    } catch (error) {
      console.log(error);
      setEmptyStateLabel("connectionAPIError");
    }
  };

  const fetchFilteredJobCards = () => {
    setLoadings(true);
    getFilteredJobcards(paginationParams, appliedFilters)
      .then((response) => {
        setEmptyStateLabel("filter");
        setTotalRecords(response.data.total_jobcards);
      setAllJobCardsIds(response.data.all_jobcard_ids);
        setJobCardsList(response.data[tableJobCardState]);
        setLoadings(false);
      })
      .catch((error) => console.log(error),
      setEmptyStateLabel("connectionAPIError"));
    };

 
  const columnsHead = [
    {
      title: "Job Card No",
      dataIndex: "jc_code",
      width: "10%",
      align: "left",
      // sorter: {
      //   compare: (a, b) => a.jobcardno - b.jobcardno,
      // },
      // render: (text) => `JC${text}`,
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "12%",
      // sorter: {
      //   compare: (a, b) => a.createddate.localeCompare(b.createddate),
      // },
      render: (text) =>
      `${moment(new Date (text)).format("DD MMM YYYY")}, ${new Date(text).getHours()} : ${new Date(text).getMinutes()}`,
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "16%",
    },
    // {
    //   title: "Number of Orders",
    //   dataIndex: "nooforders",
    //   width: "12%",
    //   align: "center",
    //   // sorter: {
    //   //   compare: (a, b) => a.nooforders - b.nooforders,
    //   // },
    // },
    {
      title: "Trim Loss",
      dataIndex: "trimloss",
      width: "9%",
      render: (text) => (text ? `${text} %` : ""),
    },
    {
      title: "Production Weight",
      dataIndex: "job_card_weight",
      width: '9%',
      render: (text, record) => {
        return `${text} ${unitData ? capitalize(unitData.units_management.weight.default) : 'T'}`
      }
    },
    {
      title: "Paper Machine",
      dataIndex: "machine",
      width: "9%",
    },
    {
      title: "Finishing Process",
      dataIndex: "process",
      width: "12%",
      render: (text) => ( <p dangerouslySetInnerHTML = {{ __html : text}}></p>)
      

    },
    {
      title: "Finishing Machine",
      dataIndex: "code",
      width: "9%",
    },
    {
      title: "Created By",
      dataIndex: "createdby",
      width: "10%",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this job card"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => JobDetailChange(record)}
                disabled={!userDetails.roles.job_cards.view}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const generateReport = async (reportType) => {
    try{

      setReportGenerating(true);
      isAllSelectedClicked ?await downloadJobcardsExcel(allJobCardsIds,reportType):await downloadJobcardsExcel(selectedRowKeys,reportType);
      setTimeout(()=>setReportGenerating(false),1200);
      setGenerateReportModalVisible(false);
      setIsAllSelectedClicked(false);
      setSelectedRowKeys([]);
    }
    catch(e){
      console.log(e);
    }
  };

  const JobDetailChange = (jobcard) => {
    if (jobcard.type === 'multi_stage') {
      navigate("../job-card-details-multistage", { state: { id: jobcard.jobcardno, jobcardType: jobcard.type, src_pathname: "job-card-summary-report" } });
      return;
    }
    if(jobcard.machine_type === 'cutter')
      navigate("../sheet-job-card-details", { state: { id: jobcard.jobcardno,type:'deckle',cutter_type:jobcard.cutter_type, jobcardType: jobcard.type, src_pathname: "job-card-summary-report" } });
    else
      navigate("../job-card-details", { state: { id: jobcard.jobcardno, jobcardType: jobcard.type, src_pathname: "job-card-summary-report" } });
  };

 

  const getTabledata = () =>
    jobCardsList.map((job) => {
      let formattedCode = getJCCode(job.jc_code);
      return {
        key: job.jc_id,
        jc_code: formattedCode,
        jobcardno: job.jc_id,
        createddate: job.created_date,
        // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
        //   job.quality ? `${job.quality}` : "-"
        // }/${job.moisture ? job.moisture : '-'}`,
        productspec: job.product_spec,
        grade: job.grade,
        gsm: job.gsm,
        burst_factor: job.burst_factor,
        quality: job.quality,
        nooforders: job.no_of_orders,
        trimloss: job.total_trim_loss_percentage?.toFixed(3),
        machine: job.machine,
        createdby: job.created_by,
        machine_type : job.machine_type,
        code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
        name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
        cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
        process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
        profile_picture: job.profile_picture ? `${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
        type: job?.type,
        job_card_weight: `${job?.job_card_weight ? job.job_card_weight.toFixed(3) : 0} `

      };
    });

  

  const searchOrders = async (value = "") => {
    setSearchValue(value);
    fetchJobCardsList({
      page: 1,
      size: 50,
    },value,appliedFilters);
  };


 
 
  useEffect(() => {

    if(rendering)
    {
    fetchJobCardsList(paginationParams,searchValue,appliedFilters);
    setRendering(false);
    }
  }, [rendering]);

  // useEffect(() => {
  //     fetchFilteredJobCards();
    
  // }, [appliedFilters, paginationParams, tableJobCardState]);

  useEffect(() => {
    const jcards = jobCardsList ? getTabledata() : []
    const result = selectedRowKeys.filter((f) =>
        jcards.some((d) => d.key == f)
      );

      if (result.length === jcards.length) setIsAllSelected(true);
      else setIsAllSelected(false);
    setTableData(jcards);
  }, [jobCardsList]);


  

  useEffect(async () => {
  const orderMangSettings = await getWorkflowSettings("order_management");
  setOrderManagementSettings(orderMangSettings.data);
  setTableJobCardState(orderMangSettings.data?.fetch_balance_quantity?.value ? 'active' : 'pending');
  const deckleMangSettings = await getWorkflowSettings("deckle_management");
  setDeckleManagementSettings(deckleMangSettings?.data);
}, []);

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel){
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }
  else{
    setEmptyStatePropsData();
  }
  },[emptyStateLabel]);

  const refresh  = () => {
      fetchJobCardsList(paginationParams, searchValue,appliedFilters);
   
  }

  const handleSelect = (record, selected) => {
      //setPageLoaded(false);
      let allKeys = [];
      let index;
      if (selected) {
        record.select = true;
        setSelectedRowKeys((keys) => [...keys, record.key]);
        allKeys = [...selectedRowKeys, record.key];
      } else {
        record.select = false;
        setSelectedRowKeys((keys) => {
           index = keys.indexOf(record.key);
          return [...keys.slice(0, index), ...keys.slice(index + 1)];
        });
  
        allKeys = [
          ...selectedRowKeys.slice(0, index),
          ...selectedRowKeys.slice(index + 1),
        ];
  
       
      }
  
      
  
      const result = allKeys.filter((f) => tableData.some((d) => d.key == f));
  
      if (result.length === tableData.length) setIsAllSelected(true);
      else setIsAllSelected(false);
    };
  
    const toggleSelectAll = (e) => {
      // setSelectedRowKeys((keys) =>
      //   keys.length === tableData.length ? [] : tableData.map((r) => r.key)
      // );

      const newCheckboxState = [...tableData];
  
      if (!e.target.checked) {
        setIsAllSelected(false);
        newCheckboxState.forEach((item) => {
          item.select = false;
        });
        
        setSelectedRowKeys(
          [...selectedRowKeys.filter((f) => !tableData.some((d) => d.key == f))]
        );
      } else {
        setIsAllSelected(true);
        newCheckboxState.forEach((item) => {
          item.select = true;
        });
       
        
  
        let uniqueKeys = [
          ...new Set([
            ...selectedRowKeys,
            ...tableData.map((item) => item.key),
          ]),
        ];
        setSelectedRowKeys([...uniqueKeys]);
      }
  
      setTableData([...newCheckboxState]);
      //tableDataRef.current = newCheckboxState;
      
    };

    const onClearSelection = () => {
      setSelectedRowKeys([]);
      setIsAllSelected(false);
    }
  
 const headerCheckbox = (
    <div style={{ paddingBottom: "4px" }}>
      <Styled>
        <Checkbox
          checked={isAllSelected}
          indeterminate={
            selectedRowKeys &&
            selectedRowKeys.length > 0 &&
            selectedRowKeys.length < tableData
          }
          onChange={
            toggleSelectAll
          }
        >
        </Checkbox>
      </Styled>
    </div>
  );


  return orderManagementSettings && deckleManagementSettings ? (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title="Job Cards"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => {
                setGenerateReportModalVisible(true);
                setIsAllSelectedClicked(true);
              }}
              loading={isReportGenerating}
            >
              {!isReportGenerating && (
                <Iconmoon icon="edit" size={14} color="#EA655B" />
              )}
              {!isReportGenerating && "Select all & Generate"}
            </Button>,
            <Button
              key="2"
              style={{ width: "160px" }}
              className="themeBtn"
              onClick={() => setGenerateReportModalVisible(true)}
              disabled={!selectedRowKeys?.length}
              loading={isReportGenerating}
            >
              {!isReportGenerating && (
                <Iconmoon icon="edit" size={14} color="#ffffff" />
              )}
              {!isReportGenerating && "Generate Report"}
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
     
        <TableLayoutData>
          <div className="tableDataFormat">
            <StyledTab>
             
                    <SearchContainer
                    placeholder={"Search JobCard No"}
                    fetchOrder={searchOrders}
                    clearSearch={clearSearch}
                    setClearSearch={setClearSearch}
                    searchedValue={searchValue}
                      // filterOptions={[
                      //   {
                      //     key: 0,
                      //     label: "Filter by Created Date",
                      //     value: "created_date",
                      //     type: "date",
                      //   },
                      //   {
                      //     key: 1,
                      //     label: "Filter by GSM",
                      //     value: "gsm",
                      //     type: "inputSelect",
                      //   },
                      //   {
                      //     key: 2,
                      //     label: "Filter by Grade/Quality",
                      //     value: "grade_quality",
                      //     type: "grade",
                      //   },
                      //   {
                      //     key: 3,
                      //     label: "Filter by Burst Factor",
                      //     value: "burst_factor",
                      //     type: "inputSelect",
                      //   },
                      //   {
                      //     key: 4,
                      //     label: "Filter by Reel OD",
                      //     value: "reel_od",
                      //     type: "inputSelect",
                      //     unitType:"length"
                      //   },
                      //   {
                      //     key: 5,
                      //     label: "Filter by Core ID",
                      //     value: "core_id",
                      //     type: "inputSelect",
                      //     unitType:"length"
                      //   },
                      //   {
                      //     key: 6,
                      //     label: "Filter by Finishing Process Type",
                      //     value: "machine_type",
                      //     type: "multiSelect",
                      //   },
                      // ]}
                      applyFilter={applyfilter}
                      hideExport={true}
                      showModifiedDateFilter={true}
                      modifiedFilterLabel={modifiedFilterLabel}
                      setModifiedFilterLabel={setModifiedFilterLabel}
                    />
                     <Row
                                            gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                                            style={{ marginBottom: "10px", marginTop: "5px" }}
                                          >
                                            <Col style={{ width: "70%" }}>
                                              <Row
                                                gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                                                style={{
                                                  marginLeft: "-30px",
                                                  marginBottom: "-10px",
                                                }}
                                              >
                                                 <Col
                                                  className="gutter-row"
                                                  style={{
                                                    width: "auto",
                                                    marginBottom: "10px",
                                                    paddingLeft: "0px",
                                                    paddingRight: "0px",
                                                  }}
                                                >
                                                  {" "}
                                                  <OrderFilter
                                                    filterType={{
                                                      key: 1,
                                                      label: "Filter by Status",
                                                      value: "jc_status",
                                                      type: "multiSelect",
                                                      name: "Status",
                                                    }}
                                                    applyFilter={applyfilter}
                                                  jobcardStatus = {JobcardStatus}
                                                  ></OrderFilter>
                                                </Col>
                                                <Col
                                                  className="gutter-row"
                                                  style={{
                                                    width: "auto",
                                                    marginBottom: "10px",
                                                    paddingLeft: "0px",
                                                    paddingRight: "0px",
                                                  }}
                                                >
                                                  {" "}
                                                  <OrderFilter
                                                    filterType={{
                                                      key: 2,
                                                      label: "Filter by Created Date",
                                                      value: "created_date",
                                                      type: "date",
                                                      name: "Created Date",
                                                    }}
                                                    applyFilter={applyfilter}
                                                  ></OrderFilter>
                                                </Col>
                                               
                                                <Col
                                                  className="gutter-row"
                                                  style={{
                                                    width: "auto",
                                                    marginBottom: "10px",
                                                    paddingLeft: "0px",
                                                    paddingRight: "0px",
                                                  }}
                                                >
                                                  {" "}
                                                  <SearchContainer
                                                    style={{ padding: "0px !important" }}
                                                    filterOptions={[
                                                      {
                                                        key: 0,
                                                        label: "Filter by GSM",
                                                         value: "gsm",
                                                          type: "inputSelect",
                                                      },
                                                      {
                                                        key: 1,
                                                        label: "Filter by Grade/Quality",
                                                        value: "grade_quality",
                                                        type: "grade",
                                                      },
                                                      {
                                                        key: 2,
                                                        label: "Filter by Burst Factor",
                                                        value: "burst_factor",
                                                        type: "inputSelect",
                                                      },
                                                           {
                                                        key: 3,
                                                        label: "Filter by Reel OD",
                                                        value: "reel_od",
                                                        type: "inputSelect",
                                                        unitType: "length",
                                                      },
                                                      {
                                                        key: 4,
                                                        label: "Filter by Core ID",
                                                        value: "core_id",
                                                        type: "inputSelect",
                                                        unitType: "length",
                                                      },
                                                                                  {
                                                    key: 5,
                                                    label: "Filter by Finishing Process Type",
                                                    value: "machine_type",
                                                    type: "multiSelect",
                                                  },
                                                    ]}
                                                    applyFilter={applyfilter}
                                                    isOtherFilter={true}
                                                    hideExport={true}
                                                  />
                                                </Col> 
                                              </Row>
                                            </Col>
                                            <Col style={{ width: "30%" }}>
                                              <OrderDetails style={{ height: "100%" }}>
                                                <div
                                                  className="pendingDetailsStyle"
                                                  style={{
                                                    paddingBottom: "0px",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  <span className="pendingOrderStyle">
                                                    {" "}
                                                    Selected Job Cards:{" "}
                                                    {selectedRowKeys?.length
                                                      ? selectedRowKeys.length
                                                      : 0}
                                                  </span>{" "}
                                                  Total Job Cards:{" "}
                                                    {totalRecords
                                                      ? totalRecords
                                                      : 0}
                                                </div>
                                              </OrderDetails>
                                            </Col>
                                          </Row>
                                          <OrderDetails>
                                                                <div
                                                                  className="pendingDetailsStyle"
                                                                  style={{ marginTop: "10px" }}
                                                                >
                                                                  <Button
                                                                    key="1"
                                                                    className="textTypeBtn textBtnIcon"
                                                                    onClick={onClearSelection}
                                                                  >
                                                                    Clear Selection
                                                                  </Button>
                                                                </div>
                                                              </OrderDetails>
                    {filterTags.map((filter) => (
                      <span className="filter-tags">
                        <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                        &nbsp;
                        <span>{filter.formattedType}</span>
                        &nbsp;
                        <span>{filter.operand}</span>
                        &nbsp;
                        <span>{filter.value}</span>
                        <span>
                          {" "}
                          <button
                            onClick={() => {
                              removeFilter(filter);
                            }}
                          >
                            {" "}
                            <Iconmoon
                              icon="wrong"
                              size={15}
                              color="#a8a8a8"
                            />{" "}
                          </button>
                        </span>
                      </span>
                    ))}
                    {loadings ? (
                    <TableShimmer
                      header = {columnsHead}
                      // scroll={1000}
                    />
                  ) :
                    tableData?.length ? (
                    <Table
                      columns={columnsHead}
                      dataSource={tableData}
                      onChange={onChange}
                      pagination={{
                        current: paginationParams.page,
                        total: totalRecords,
                        showTitle: false,
                          defaultPageSize: 50,
                          pageSize: paginationParams.size,
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                        pageSizeOptions: [10, 20, 50, 100],
                        showSizeChanger: true,
                        // locale: { items_per_page: "" },
                        
                      }}
                      scroll={{ x: 1500 }}
                      rowSelection={{
                          columnWidth: "1.5%",
                          selectedRowKeys,
                          columnTitle: headerCheckbox,
                          onSelect: handleSelect,
                        }}
                    />) : (
                      <EmptyState
                      img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
                      emptyStateLabel === "search" ? emptyState_Search : 
                      emptyState_ConnectionAPIError}
                      heading= {emptyStatePropsData?.heading}
                      subHeading= {emptyStatePropsData?.subHeading}
                      label={emptyStatePropsData?.label}
                      refresh={refresh}
                      />
                    )}
                
            </StyledTab>
          </div>
        </TableLayoutData>
        <GenerateReportModal 
          isGenerateReportModalVisible = {isGenerateReportModalVisible}
          setGenerateReportModalVisible = {setGenerateReportModalVisible}
          generateReport = {generateReport}
        >
        </GenerateReportModal>
    </RightLayoutContainer>
  ) : (
    ""
  );
};
export default JobcardSummaryReport;